import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/tags'],
  validationMode: 'any',
};

export const tagsSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.TagsSetup,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Configure Your Tags',
  description: initRawSchema(
    `Principle utilises various types of tags to convey information about patients, appointments, notes, and more. These tags allow the easy communication of information, trigger automations, and serve as filters for reporting. When migrating from an existing PMS, various datapoints can be converted into tags.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/tags`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
};
